var render, staticRenderFns
import script from "./DiscussionList.vue?vue&type=script&lang=js"
export * from "./DiscussionList.vue?vue&type=script&lang=js"
import style0 from "./DiscussionList.vue?vue&type=style&index=0&id=1666ddde&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1666ddde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/honeypot.learningsystem.de/releases/20260624084000/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1666ddde')) {
      api.createRecord('1666ddde', component.options)
    } else {
      api.reload('1666ddde', component.options)
    }
    
  }
}
component.options.__file = "resources/js/components/DiscussionList.vue"
export default component.exports